export { default, default as Footer } from './Footer'
export * as FooterStyles from './styles/Footer.style'
export { default as footerTheme } from './themes/Footer.theme'

export type { AppearanceKeys, FooterTheme } from './themes/Footer.theme.types'
export type { FooterProps } from './Footer.types'
export type { StyledFooterProps } from './styles/Footer.style.types'
